import React, { useEffect } from 'react';
import { ConfirmFormSubmitModal } from '../../../common/components/confirm-form-submit-modal/confirm-form-submit-modal';

export type QuantityUpdateConfirmModalType = {
  isModalVisible: boolean;
  onModalShow?: () => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export function QuantityUpdateConfirmModal({
  isModalVisible,
  onModalShow,
  onCancel,
  onConfirm,
}: QuantityUpdateConfirmModalType) {
  useEffect(() => {
    if (isModalVisible && onModalShow) {
      onModalShow();
    }
  }, [isModalVisible]);
  return (
    <ConfirmFormSubmitModal
      visible={isModalVisible}
      heading="Reduce quantity?"
      subtext="This will remove devices from your delivery addresses starting from the last added address."
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
